import { CartAddEvent } from '@theme/events';

class LyastoneGiftBox extends HTMLElement {
  static busy = false;
  connectedCallback() {
    if (this.bound) return;
    this.bound = true;
    this.addEventListener('click', (event) => {
      if (event.target.closest('.ly-gift-box__button')) this.addBox();
    });
  }
  async addBox() {
    if (LyastoneGiftBox.busy || !this.dataset.variantId) return;
    const button = this.querySelector('button');
    if (!button || button.disabled) return;
    LyastoneGiftBox.busy = true;
    const original = button.textContent;
    const status = this.querySelector('[role="status"]');
    const check = this.querySelector('.ly-gift-box__check');
    let accepted = false;
    let rejected = false;
    let synced = false;
    button.disabled = true;
    button.textContent = this.dataset.loading;
    this.setAttribute('aria-busy', 'true');
    status.textContent = '';
    check.hidden = true;
    try {
      const sectionIds = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
      const response = await fetch(this.dataset.addUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: this.dataset.variantId, quantity: 1 }], sections: sectionIds, sections_url: location.pathname + location.search })
      });
      const result = await response.json();
      if (!response.ok || result.status) {
        rejected = true;
        throw new Error(result.description || this.dataset.error);
      }
      accepted = true;
      status.textContent = this.dataset.added;
      const cartResponse = await fetch(this.dataset.cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!cartResponse.ok) throw new Error(this.dataset.uncertain);
      const cart = await cartResponse.json();
      document.dispatchEvent(new CartAddEvent(cart, 'lyastone-gift-box', {
        source: 'lyastone-gift-box', itemCount: cart.item_count,
        variantId: this.dataset.variantId, sections: result.sections || {}
      }));
      synced = true;
      if (sectionIds.some(id => !result.sections?.[id])) {
        check.hidden = false;
      }
    } catch (error) {
      status.textContent = rejected ? error.message : this.dataset.uncertain;
      check.hidden = rejected;
      if (!rejected) button.dataset.checkCart = 'true';
    } finally {
      this.removeAttribute('aria-busy');
      LyastoneGiftBox.busy = false;
      if (button.isConnected) {
        if (!synced) button.textContent = original;
        button.disabled = !synced && (accepted || button.dataset.checkCart === 'true');
      }
    }
  }
}
if (!customElements.get('lyastone-gift-box')) customElements.define('lyastone-gift-box', LyastoneGiftBox);
